module.exports = __webpack_public_path__ + "img/bio-purple-8.e7d9977.jpg";